import Vue from 'vue'
import VueX from 'vuex'

Vue.use(VueX)

import currencyService from '../service/currency'

export default new VueX.Store({
  state: {
    currencies: null
  },
  mutations: {
    setCurrencies (state, currencies) {
      state.currencies = currencies
    }
  },
  actions: {
    SET_CURRENCIES ({commit}, payload) {
      commit('setCurrencies', payload)
    },
    GET_CURRENCIES ({dispatch}) {
      return new Promise((resolve) => {
        currencyService.fetch().then(v => {
          dispatch('SET_CURRENCIES', v.result)
          resolve(true)
        })
      })
    }
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js